import numeral from 'numeral';
import 'numeral/locales.js';

export default defineNuxtPlugin(() => ({
  provide: {
    changeNumeralLocale: (localeName) => {
      numeral.locale(localeName);
    }
  }
}));
